import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fdeaee46&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdeaee46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdeaee46')) {
      api.createRecord('fdeaee46', component.options)
    } else {
      api.reload('fdeaee46', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fdeaee46&scoped=true", function () {
      api.rerender('fdeaee46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/level/index.vue"
export default component.exports